import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { Formik, Field } from 'formik'
import { Button, Form } from 'lib/ui'
import { schema, validation, Values } from './schema'

interface Props {
  onCancel: () => void
  onSubmit: (values: Values) => void
  isFetching: boolean
}

export const ResetPasswordForm: React.FC<Props> = ({
  isFetching,
  onSubmit,
  onCancel
}) => {
  const intl = useIntl()

  return (
    <Formik
      initialValues={schema}
      validationSchema={validation(intl)}
      onSubmit={onSubmit}
    >
      <Form.Wrapper>
        <Field
          name='password'
          label={intl.formatMessage({
            id: 'customer.account.reset.label.password'
          })}
          component={Form.Input}
          type='password'
          isRequired
        />

        <Field
          name='passwordRetype'
          label={intl.formatMessage({
            id: 'customer.account.reset.label.passwordRetype'
          })}
          component={Form.Input}
          type='password'
          isRequired
        />

        <div className='actions'>
          <Button
            type='submit'
            isLoading={isFetching}
          >
            <FormattedMessage id='action.setNewPassword' />
          </Button>

          <Button
            skin={Button.SKIN.OUTLINE}
            isDisabled={isFetching}
            onClick={onCancel}
          >
            <FormattedMessage
              id='action.cancel'
            />
          </Button>
        </div>
      </Form.Wrapper>
    </Formik>
  )
}
